import useUserStore from '@/stores/userStore';

// BOXY-49 — the Updates tab flag rides on GET /v1/user (`setting.order_updates_tab`).
// Missing = off: the tab button is hidden and /updates is never requested.
const useOrderUpdatesEnabled = (): boolean =>
  useUserStore((state) => state.user?.setting?.order_updates_tab === true);

export default useOrderUpdatesEnabled;
